import React from 'react'

const SubmitClaim = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={80}
                height={80}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <g fillRule="evenodd" clipRule="evenodd">
                        <path
                            fill="#c5dcf1"
                            d="M53.5 30.8h285.4c9.8 0 17.8 8 17.8 17.8V463c0 9.8-8 17.8-17.8 17.8H53.5c-9.8 0-17.8-8-17.8-17.8V48.6c0-9.8 8-17.8 17.8-17.8z"
                            opacity={1}
                            data-original="#7fcbb4"
                            className=""
                        />
                        <path
                            fill="#f1d734"
                            d="M356.7 445.7C292 409.8 246 344.5 236.8 267.7c9.7-8.3 18.1-18.4 24.9-30.1 3.5-6 6.3-12.2 8.6-18.6 27.8-3.5 56.7-5.4 86.3-5.4 29.7 0 58.5 1.9 86.3 5.4 2.3 6.3 5.2 12.5 8.6 18.6 6.8 11.7 15.2 21.8 24.9 30.1-8.9 76.8-55 142.1-119.7 178z"
                            opacity={1}
                            data-original="#fcb13b"
                            className=""
                        />
                        <path
                            fill="#1975c9"
                            d="M137.2 374.3h-26.1c-18.4 0-33.5 18-33.5 40.1v17.8h93.1v-17.8c0-22.1-15.1-40.1-33.5-40.1z"
                            opacity={1}
                            data-original="#d71b5a"
                            className=""
                        />
                        <path
                            fill="#fad1a2"
                            d="M124.1 319.4c-16.6 0-30.1 13.5-30.1 30.1s13.5 30.1 30.1 30.1 30.1-13.5 30.1-30.1-13.4-30.1-30.1-30.1z"
                            opacity={1}
                            data-original="#fad1a2"
                            className=""
                        />
                        <path
                            fill="#60a9eb"
                            d="M356.7 247.7c35.4 0 64 28.7 64 64s-28.6 64-64 64c-35.3 0-64-28.7-64-64s28.7-64 64-64z"
                            opacity={1}
                            data-original="#9695c9"
                            className=""
                        />
                    </g>
                    <path
                        d="M364.7 450.3V463c0 14.2-11.6 25.8-25.8 25.8H53.5c-14.2 0-25.8-11.6-25.8-25.8V48.6c0-14.2 11.6-25.8 25.8-25.8h285.4c14.2 0 25.8 11.6 25.8 25.8v157.1c26.6.3 53 2.1 79.3 5.4 3.1.4 5.5 2.5 6.5 5.2 2 5.7 5 12.1 8.1 17.3 6.1 10.6 14.1 20.2 23.2 28 2.1 1.8 3 4.5 2.7 7-9.1 76.5-53.9 143.5-119.8 181.7zm-44.8-137.8c-2.9-3.3-2.5-8.4.9-11.3s8.4-2.5 11.3.9l15 17.4L379 283c2.9-3.3 7.9-3.7 11.3-.8 3.3 2.9 3.7 7.9.8 11.3l-38.8 44.2c-3.3 2.9-8.4 2.5-11.3-.9zm36.8-72.8c39.7 0 72 32.2 72 72s-32.3 72-72 72c-39.8 0-72-32.2-72-72s32.3-72 72-72zm39.6 32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2 57.3 21.9 79.2 0c21.9-21.8 21.9-57.3 0-79.2zM69.2 169.2c-4.4 0-8-3.6-8-8s3.6-8 8-8h253.9c4.4 0 8 3.6 8 8s-3.6 8-8 8zm31.1-53c0-4.4 3.6-8 8-8s8 3.6 8 8v2.7c0 10.9-8.8 19.7-19.7 19.7h-9.9c-10.9 0-19.7-8.8-19.7-19.7V78.6C67 67.8 75.8 59 86.7 59h9.9c10.9 0 19.7 8.8 19.7 19.7v2.7c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-2.2.3-3.9-1.1-5.3-.7-.7-1.6-1.1-2.6-1.1h-9.9c-2 0-3.7 1.7-3.7 3.7V119c0 2 1.7 3.7 3.7 3.7h9.9c2 0 3.7-1.7 3.7-3.7zm148.6 14.4c0 4.4-3.6 8-8 8s-8-3.6-8-8V67c0-4.4 3.6-8 8-8s8 3.6 8 8zm28.7 0c0 4.4-3.6 8-8 8s-8-3.6-8-8V67c0-8.3 11.6-11.5 15.4-3l16.4 32.1 16.8-32.8c3.8-7.4 15.1-4.7 15.1 3.6v63.6c0 4.4-3.6 8-8 8s-8-3.6-8-8V100l-8.8 17.2c-2.9 5.7-11.2 5.8-14.2 0l-8.8-17.2v30.6zm-90.8 0c0 4.4-3.6 8-8 8s-8-3.6-8-8V80.3c0-11.8 9.6-21.4 21.4-21.4h6.6c11.8 0 21.4 9.6 21.4 21.4v50.3c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.2h-17.3v9.2zm0-50.3v25h17.3v-25c0-2.9-2.4-5.4-5.4-5.4h-6.6c-2.9.1-5.3 2.5-5.3 5.4zm-31 42.3c4.4 0 8 3.6 8 8s-3.6 8-8 8H133c-4.4 0-8-3.6-8-8V67c0-4.4 3.6-8 8-8s8 3.6 8 8v55.6zm-86.6 96.2c-4.4 0-8-3.6-8-8s3.6-8 8-8h160.4c4.4 0 8 3.6 8 8s-3.6 8-8 8zm0 69.5c-4.4 0-8-3.6-8-8s3.6-8 8-8h103.3c4.4 0 8 3.6 8 8s-3.6 8-8 8zm0-34.7c-4.4 0-8-3.6-8-8s3.6-8 8-8h124.7c4.4 0 8 3.6 8 8s-3.6 8-8 8zm54.9 73.8c-19.6 0-29.5 23.8-15.6 37.7s37.7 4 37.7-15.6c0-12.2-9.9-22.1-22.1-22.1zm-26.9-4.8c14.9-14.9 39-14.9 53.9 0 13 13 14.9 33.5 4.4 48.6 14.7 8.4 23.3 25.6 23.3 43.1v17.8c0 4.4-3.6 8-8 8H77.6c-4.4 0-8-3.6-8-8v-17.8c0-17.6 8.5-34.8 23.3-43.1-10.6-15.1-8.7-35.6 4.3-48.6zm45.2 60.3c-19.2 10.5-36.1 0-36.5 0-5.2 1.4-9.8 4.8-13.4 9.5-4.3 5.8-6.9 13.4-6.9 21.9v9.8h77.2v-9.8c-.1-13.7-7.6-28-20.4-31.4zm206.3-177.1V48.6c0-5.4-4.4-9.8-9.8-9.8H53.5c-5.4 0-9.8 4.4-9.8 9.8V463c0 5.4 4.5 9.8 9.8 9.8h285.4c5.4 0 9.8-4.4 9.8-9.8v-12.7C282.9 412.2 238 345.1 228.9 268.7c-.3-2.9.9-5.6 3.1-7.3 4.4-3.8 8.5-8.1 12.4-12.7 7.9-9.5 14.3-20.6 18.5-32.3 1.1-3.1 3.9-5 6.9-5.2 14.2-1.8 28.5-3.1 42.9-4.1 12-.8 24-1.2 36-1.3zm-66.9 160.7c19.3 28.7 45 52.7 74.9 70 60.2-35 101.8-95.9 111.4-165.6-9.2-8.5-17-18.2-23.4-29.2-2.7-4.6-5.5-10.4-7.5-15.3-52.8-6.3-108.4-6.3-161.2 0-6.8 16.8-17.5 32.2-30.8 44.5 4.9 35 17.7 67.5 36.6 95.6z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default SubmitClaim